import React from 'react'
import PropTypes from 'prop-types'
import FormInput from '../formInput/FormInput'
import NotificationBox from '../notificationBox/NotificationBox'
import PasswordCriteriaMet from '../passwordSection/PasswordCriteriaMet'
import { TooltipIcon } from 'carbon-components-react'
import { Information24 } from '@carbon/icons-react'

export const TextInputType = 'textInput' 
export const CheckboxType = 'checkbox'
export const PasswordType = 'password'

export default function FormContainer( props ) {
    return (
        <>
            <div className='label-icon-box'>
                <h2 className={ props.formTitleClassName } tabIndex= { 0 } aria-label = { props.formTitleAdaMsg ? props.formTitleAdaMsg : '' } >{ props.formTitle }</h2>
                {
                    props.tooltipConfiguration?.visible && (
                        <TooltipIcon data-testid="show-tooltip" tooltipText = { props.tooltipConfiguration?.text  } >
                            <Information24 />
                        </TooltipIcon>
                    )
                }
            </div>
            <div className={ props.containerClassName }>
                { props.notificationVisible && props.notificationType == PasswordType && !props.displayNotificacionBottom && 
                    <PasswordCriteriaMet 
                        { ...props.notification }
                    />
                }
                {props.showInputComponentsInColum && (
                    <div className={ `${ props.formInputsClass ? props.formInputsClass : '' } ${ !props.notificationVisible ? 'c-form-container-in-column--no-notification' : '' } ` }>
                        { props.formInputComponents.map( ( formInputComponent ) => {
                            return (
                                <FormInput 
                                    tabIndex={ 0 }
                                    key={ `formInput-${ formInputComponent.id }` }
                                    { ...formInputComponent }
                                />
                            )
                            } )}
                    </div>  
                )}
                {!props.showInputComponentsInColum && (
                    props.formInputComponents.map( ( formInputComponent ) => {
                        return (
                            <div className= { props.formInputComponents.length > 1 ? 'c-form-container-in-row' : 'c-form-container-in-row--one-element' } key={ `div-${ formInputComponent.id }` }>
                                <FormInput 
                                    tabIndex={ 0 }
                                    { ...formInputComponent }
                                />
                            </div>
                        )
                        } )
                )}
                { props.notificationVisible && props.notificationType == undefined &&
                    <NotificationBox 
                        { ...props.notification }
                    />
                }
                { props.notificationVisible && props.notificationType == PasswordType && props.displayNotificacionBottom &&
                    <PasswordCriteriaMet 
                        { ...props.notification }
                    />
                }
            </div>
            { props.children }
        </>
    )
}

FormContainer.propTypes = {
    formTitle: PropTypes.string,
    formTitleAdaMsg: PropTypes.string,
    formTitleClassName: PropTypes.string,
    containerClassName: PropTypes.string,
    formInputComponents: PropTypes.arrayOf( PropTypes.instanceOf( Object ) ),
    children: PropTypes.node,
    notification: PropTypes.shape( {
        visible: PropTypes.bool,
        contentWrapper: PropTypes.string,
        //password
        pswLength: PropTypes.string,
        pswSpecial: PropTypes.string,
        pswNumber: PropTypes.string,
        pswLetter: PropTypes.string,
    } ),
    notificationVisible: PropTypes.bool,
    displayNotificacionBottom: PropTypes.bool,
    notificationType: PropTypes.string,
    showInputComponentsInColum: PropTypes.bool,
    tooltipConfiguration : PropTypes.shape( { 
        text : PropTypes.string,
        visible : PropTypes.bool,
    } ),
    formInputsClass: PropTypes.string
}